import { render, staticRenderFns } from "./class-student.vue?vue&type=template&id=17eb0c76&scoped=true&"
import script from "./class-student.vue?vue&type=script&lang=ts&"
export * from "./class-student.vue?vue&type=script&lang=ts&"
import style0 from "./class-student.vue?vue&type=style&index=0&id=17eb0c76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb0c76",
  null
  
)

export default component.exports